<template>
  <blueprint-wrapper>
    <blueprint-header>
      <app-header-base/>
    </blueprint-header>
    <blueprint-content>
      <router-view/>
    </blueprint-content>
    <blueprint-footer>
      <footer-lower/>
    </blueprint-footer>
  </blueprint-wrapper>
</template>

<script>
// A special layout for error pages with as little logic as possible

import AppHeaderBase from '@/layouts/components/AppHeaderBase';
import FooterLower from '@/layouts/components/AppFooterLower';
import BlueprintWrapper from '@/components/Blueprint/BlueprintWrapper';
import BlueprintHeader from '@/components/Blueprint/BlueprintHeader';
import BlueprintContent from '@/components/Blueprint/BlueprintContent';
import BlueprintFooter from '@/components/Blueprint/BlueprintFooter';

export default {
  name: 'error-layout',
  components: {
    AppHeaderBase,
    BlueprintWrapper,
    BlueprintHeader,
    BlueprintContent,
    BlueprintFooter,
    FooterLower,
  },
};
</script>
